module.exports = __webpack_public_path__ + "static/media/2.f7a5f99e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/novopolotsk/2.jpg
// module id = 244
// module chunks = 0